import React, {useState} from 'react';
import {withStyles} from "@material-ui/core";
import Layout from '../../components/Layout';
import i18n from '../../i18n';
import ContractGrid from "../../components/Contracts/ContractGrid";
import Toolbar from "../../components/Toolbar/Toolbar";
import FileUploadForm from '../../components/Uploader/FileUploadForm'
import Table from "@material-ui/core/Table/Table";
import Grid from "@material-ui/core/Grid/Grid";
import axios from "axios/index";
import MediaSearchField from "../../components/Media/SearchField";

import {
    withPaginator,
    Pagination
} from '../../components/Pagination';

const ContractsIndex = ({classes, items, personType}) => {
    // debugger;
    const [persons, setPersons] = useState(items);
    const [paginate, setPaginate] = useState(true);
    const CancelToken = axios.CancelToken;
    let cancel;

    const doSearch = (searchString) => {
        cancel && cancel();

        axios.get('/search-' + personType, {params: {'query': searchString}, cancelToken: new CancelToken(function executor(c) {cancel = c;})}).then((response) => {
            setPaginate(false);
            if (response.data && response.data.length > 0) {
                setPersons(response.data.map(item => item.entity));
            } else {
                setPersons([]);
            }
        })
    };

    return (
        <Layout>
            <Toolbar
                disableGutters
                title={i18n.get('persons.heading_' + personType)}
                // subtitle={`${pagination.total} ${i18n.get('persons.number_of_' + personType)}`}
                items={[
                    // {
                    //     icon: 'cloud_upload',
                    //     text: i18n.get('persons.import_' + personType),
                    //     href: `/importers/${personType}`,
                    // },
                    {
                        icon: 'add',
                        text: i18n.get('persons.new_' + personType),
                        href: `/persons/${personType}/create`,
                    }
                ]}
            />

            <Grid container justify="space-between" alignItems="center">
                <Grid item xs={3}>
                    <MediaSearchField
                        searchByTyping={true}
                        doSearch={doSearch}
                        label={i18n.get('default.search_' + personType)}
                    />
                </Grid>
                <Grid item xs={3}>
                    {paginate && (
                    <Table>
                        <Pagination
                            colSpan={1}
                        />
                    </Table>
                    )}
                </Grid>
            </Grid>

            <ContractGrid persons={persons}/>

            {paginate && (
            <Table>
                <Pagination
                    colSpan={1}
                />
            </Table>
            )}

            <FileUploadForm accept='.csv' lang={'persons.import_' + personType} route={'/importers/persons/' + personType}/>
        </Layout>
    );
};

const styles = theme => ({
    paper: {
        marginTop: theme.spacing.unit * 3,
        marginBottom: theme.spacing.unit * 3,
        padding: theme.spacing.unit * 2,
        [theme.breakpoints.up(600 + theme.spacing.unit * 3 * 2)]: {
            marginTop: theme.spacing.unit * 6,
            marginBottom: theme.spacing.unit * 6,
            padding: theme.spacing.unit * 3,
        },
    },
});

export default withStyles(styles)(withPaginator('pagination')(ContractsIndex));



// WEBPACK FOOTER //
// ./resources/assets/js/pages/contracts/Index.jsx